// @ts-nocheck
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const focus: Styleguide["focus"] = {
    color: "#61BC46",
    style: "auto",
    width: pxToRem(2),
};

export default focus;
